import { render } from "./OriginalInfo.vue?vue&type=template&id=36433a00"
import script from "./OriginalInfo.vue?vue&type=script&lang=ts"
export * from "./OriginalInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script